import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";
import "firebase/performance";
import "firebase/remote-config";

import "@algolia/autocomplete-theme-classic";
import "./src/styles/global.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/500-italic.css";
import "@fontsource/dm-sans/700.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";

import React from "react";
import { Provider } from "react-redux";
import UserProvider from "./src/context/user";
import FirebaseProvider from "./src/context/firebase";
import AmplitudeProvider from "./src/context/amplitude";
import store from "./src/context/store";
import { CookiesProvider } from "react-cookie";

export const wrapRootElement = ({ element }) => {
  return (
    <Provider store={store}>
      <AmplitudeProvider>
        <FirebaseProvider>
          <CookiesProvider>
            <UserProvider>{element}</UserProvider>
          </CookiesProvider>
        </FirebaseProvider>
      </AmplitudeProvider>
    </Provider>
  );
};
